module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABQElEQVR42u3asUsCYRjH8ZfEwU2EsCkChxwiQqKGakkEobUpormpIQetVKKhocag3EVyjEanxoYo8I9pCn7iwQWB4ovmgT7fF35wHAf3vp97Xu6BOyfJWY4DAAAAAAAAAAAAAAAA4wBu40ajEstdy+e6YekmN70yyT18MxbA0emhVotndgHajTXV6/s2ARJbNX2/x9V9TdsB6Jf718uS9OkGptPMaHGvPN8V0H/yD/fbfxb+87GgymXBzhYIyz8EGHcbzCzAwclxsPDW47renleC4+V8yQ7A3e1u8AoMe4Gral7n5aIdgNTOhde5mQZQBMMXIKIBAAAAAAAAAAAAAECQ7FNW044vQBRzAQAAAAAAAAAAAADgtxUe8vXnP+PdCkcwFwAAAAAAAAAAAAAA+FESAAAAAAAAAAAAAAAATKYH97BtsSbb6PQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Central-African-Republic.png
// module id = hn9R
// module chunks = 0 62 63